import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import MobileStoreQrLabel from '~/src/features/agent/components/QrLabel';

const LocalColor_OutlineDarkWithAlfa = 'rgba(155,205,221,.2)';
const LocalFont_H6 = '12px/20px CoFoSansBold, Helvetica, sans-serif';

export const BottomWrapper = styled.div`
    position: relative;
    width: 100%;
    padding: 76px 158px 92px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${LocalColor_OutlineDarkWithAlfa};
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 84px 80px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 84px 60px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 100px 40px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        padding: 40px 16px 0;
    }
`;

export const BottomContent = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    max-width: 640px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 300px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 26px;
        max-width: unset;
    }
`;

export const BottomTitle = styled.h2`
    margin-top: 0;
    margin-bottom: 24px;
    ${FONTS.H1};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H2};
        margin-bottom: 16px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H3};
        margin-left: 16px;
    }
`;

export const BottomImage = styled.div`
    position: absolute;
    top: 0;
    right: 215px;
    bottom: 0;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        right: 110px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        right: -83px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        right: -85px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: relative;
        width: 100%;
        height: 290px;
        right: 0;
    }
`;

export const BottomImageInner = styled.div`
    position: relative;
    width: 460px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 414px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: absolute;
        width: 375px;
        top: 0;
        left: 62%;
        transform: translateX(-63%);
    }
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-position: right bottom;
    object-fit: contain;
`;

export const SMobileStoreQrLabel = styled(MobileStoreQrLabel)`
    width: 134px;
    position: absolute;
    bottom: 56px;
    right: -110px;
    transform: rotate(-14deg);

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        right: -85px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 129px;
        bottom: initial;
        right: initial;
        left: 0;
        top: 65px;

        & > div:first-child {
            padding: 12px 14px;
        }

        & > div:last-child {
            font: ${LocalFont_H6};
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        display: none;
    }
`;
